<template>
  <div class="user-info">
    <div class="main-wrapper">
      <div class="info-title">
        <div class="title1">测测你是马云要找的老师吗？</div>
        <div class="under-line"></div>
        <div class="title2">「 2020年马云乡村教育人才计划申报 」</div>
      </div>
      <div class="user-name">
        <input
          type="text"
          id="name"
          v-model.trim="user_name"
          placeholder="请填写您的姓名"
          maxlength="8"
          @blur="scrollToBottom"
        />
        <label for="name">老师</label>
      </div>
      <div class="info-pic"></div>
      <div class="start-btn" @click="toAnswer">开始答题</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_name: "",
      position: ""
    };
  },
  methods: {
    toAnswer() {
      if (this.user_name) {
        let that = this;
        $.ajax({
          type: "get",
          url: "https://api.xiaoxxx.com/sensitive",
          data: { word: this.user_name },
          dataType: "jsonp",
          success: function(res) {
            if (res.code == 0) {
              if (res.data.words.length) {
                alert("您输入的名字有敏感词");
              } else {
                sessionStorage.setItem("name", that.user_name);
                that.$router.push({
                  path: "/Qusetion",
                  query: {}
                });
              }
            }
          }
        });
      } else {
        alert("请输入您的名字");
      }
    },
    scrollToBottom() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style>
.user-info {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/images/canvas-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}
.info-title {
  width: 100%;
  margin-top: 0.6rem;
  text-align: center;
  /* margin-bottom: 4rem; */
}
.under-line {
  width: 5.8rem;
  height: 1px;
  background: #303030;
  margin: 0 auto;
}
.title1 {
  font-size: 0.43rem;
  color: #ff6100;
  font-weight: bold;
}
.title2 {
  font-size: 0.35rem;
  font-weight: 600;
}
.user-name {
  text-align: center;
  font-size: 0.4rem;
  font-weight: 550;
  margin-top: 1.4rem;
}
.user-name input {
  color: #303030;
  width: 3rem;
  background: none;
  appearance: none;
  outline: none;
  outline: 0;
  border: none;
  text-align: center;
  font-size: 0.42rem;
  -webkit-appearance: none;
  border-style: none;
  border-bottom: 2px solid #949494;
  border-radius: 0px !important;
  -webkit-user-select: text !important;
  font-weight: bold;
  line-height: 1.4;
}
.user-name input:focus {
  outline: none;
}
.user-name input::-webkit-input-placeholder {
  color: #949494;
  font-weight: 550;
}
.info-pic {
  width: 4.75rem;
  height: 4.81rem;
  background-image: url("../assets/images/info-pic.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0.7rem auto;
}
.position {
  width: 100%;
  box-sizing: border-box;
  font-size: 0.5rem;
  font-weight: 550;
  padding: 0.2rem 5%;
  text-align: center;
  margin-top: 0.2rem;
}
.position-title {
  display: inline-block;
  vertical-align: middle;
  /* line-height: -0.4rem; */
}
.radio-item {
  display: inline-block;
  margin: 0 0.2rem;
  vertical-align: middle;
}

.radio_type {
  display: inline-block;
  width: 0.41rem;
  height: 0.41rem;
  appearance: none;
  position: relative;
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
  margin-right: 0.2rem;
  vertical-align: middle;
  top: -0.05rem;
}
.radio_type:before {
  content: "";
  width: 0.4rem;
  height: 0.4rem;
  border: 1px solid #000;
  display: inline-block;
  border-radius: 100%;
  vertical-align: middle;
}

.radio_type:checked:before {
  content: "";
  width: 0.4rem;
  height: 0.4rem;
  border: 1px solid #000;
  display: inline-block;
  border-radius: 100%;
  vertical-align: middle;
}

.radio_type:checked:after {
  position: absolute;
  content: "";
  width: 0.2rem;
  height: 0.2rem;
  text-align: center;
  background: #ff6100;
  border-radius: 100%;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -40%);
}

.radio_type:checked + label {
  color: #ff6100;
  /* vertical-align: middle; */
  display: inline-block;
}
label {
  line-height: 0.6rem;
  font-weight: bold;
}
.start-btn {
  position: absolute;
  bottom: 0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 4.7rem;
  height: 1.2rem;
  background: #ff6100;
  margin: 0 auto;
  text-align: center;
  font-size: 0.65rem;
  color: #f4eadf;
  border-radius: 0.125rem;
  line-height: 1.2rem;
  font-weight: bold;
  box-shadow: 6px 4px 10px 1px #fdaa78;
}
</style>